<template>
  <div class="footer-button-container">
    <button class="popup-footer-button secondary-button left" @click="handlePageChangeClick('SelectExportType')">
      <i class="fa-regular fa-chevron-left"></i>
      {{ $t('export.label.back') }}
    </button>
    <button class="popup-footer-button primary-button" :disabled="!exportButtonsAreEnabled" @click="handlePageChangeClick('CreateExport')">
      {{ $t('label.export') }}
      <i class="fa-regular fa-cloud-download"></i>
    </button>
  </div>
</template>

<script>
import '@/assets/less/colors.less'

export default {
  name: 'PreExportCheckFooter',
  props: {
    exportButtonsAreEnabled: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handlePageChangeClick(page) {
      const nextFooter = page === 'CreateExport' ? 'CreateExportFooter' : 'SelectExportTypeFooter'
      this.$emit('setNextPage', {
        nextComponent: page,
        nextFooter: nextFooter
      })
      this.$emit('goNextPage')
    }
  }
}
</script>
